import React, { ReactNode } from 'react';

import './results__table-head.scss';

interface TableHeadProps {
    children: ReactNode;
}

const TableHead = ({ children }: TableHeadProps) => {
    return <div className="results__table-head">{children}</div>;
};

export default TableHead;
